exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.searchProgressIcon[data-v-45e505c6] {\n    display: inline-block;\n    position: relative;\n    top:10px;\n}\n.connectionErrors h4[data-v-45e505c6] {\n    color:red;\n    font-size: 16px;\n}\n.connectionErrors .connectionErrorsDelete[data-v-45e505c6] {\n    display: inline-block;\n    width: 50px;\n    float:right;\n}\n.connectionErrors i[data-v-45e505c6]:hover {\n    cursor: pointer;\n}\n.statsSection[data-v-45e505c6] {\n    padding: 10px 25px;\n}\n.statsSection div[data-v-45e505c6] {\n    padding: 2px 0;\n}\n\n", ""]);

// exports
